import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from '../../../services/session'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            editId: -1,
            displayName: '',
            name: '',
            title: '',
            fieldItems: [],
            fieldsData: new Map()
        }
    },
    methods: {
        signUp: signUp,
        load: load,
        handleChange: handleChange,
        editSignUp: editSignUp,
        loadMyData: loadMyData,
    },
    beforeMount() {
        this.id = this.$route.query.id;
        this.displayName = this.$route.query.name;
        this.load()
    }
}

function handleChange(key, value){
    this.fieldsData.set(key, value);
}

function loadMyData(){
    let _self = this;
    AdminApiService.getEventDataForCompanyInfo(this.id)
        .then((response) => {
           if(response.data.id != null){
               _self.editId = response.data.id;
               let addInfo = JSON.parse(response.data.additionalInfo)
               for (const [key, value] of Object.entries(addInfo)) {
                   if(_self.fieldItems.includes(key)){
                       _self.fieldsData.set(key, value)
                   }
               }
               _self.$forceUpdate();
           }
        })
        .catch((error) => {
            console.log(error)
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function load(){
    let _self = this;
    AdminApiService.getCompanyInfoById(this.id)
        .then((response) => {
            let addInfo = JSON.parse(response.data.additionalInfo)
            _self.fieldItems = addInfo.fields.split(";").filter( i => i.length > 0);
            _self.fieldsData = new Map();
            _self.loadMyData()
        })
        .catch((error) => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function signUp(){
    let _self = this;
    for(var i = 0; i < this.fieldItems.length; i++){
        if(this.fieldsData.get(this.fieldItems[i]) == null){
            swal(LocService.t('label_error'), LocService.t('label_invoice_all_field_required'), 'error')
            return;
        }
    }
    if(this.editId !== -1){
        this.editSignUp()
        return;
    }
    let newModel = {
        companyInfoId : this.id,
        additionalInfo: JSON.stringify(Object.fromEntries(this.fieldsData))
    }
    AdminApiService.signUpForEvent(newModel)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_ci_event_successfully_sign_up'), 'success')
            _self.loadMyData();
        })
        .catch(error => {
            console.log(error)
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function editSignUp(){
    let newModel = {
        eventId : this.editId,
        additionalInfo: JSON.stringify(Object.fromEntries(this.fieldsData))
    }
    AdminApiService.updateSignUpForEvent(newModel)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_ci_event_successfully_sign_up'), 'success')
        })
        .catch(error => {
            console.log(error)
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Home/Event/SignUpForEvent.js